import {boundMethod} from "autobind-decorator";
import React from "react";
import {injectIntl, IntlShape} from "react-intl";
import {Link} from "react-router-dom";

import networkDevices, {IDeviceStatus} from "@/services/network-devices";

import Card from "@toolbox/design/Card";
import Time from "@toolbox/design/Time";
import {device2ServerId} from "@toolbox/functions/device-check";
import T, {intl2Num} from "@translate/T";

interface IDeviceProps {
    intl: IntlShape;
    device: IDeviceStatus;
}

class Device extends React.PureComponent<IDeviceProps> {
    public render() {
        const {
            intl,
            device: {device, isOnline, lastMessage, state},
        } = this.props;

        return (
            <Card
                title={networkDevices.getDeviceName(intl, device)}
                headerClassName={`bg-${isOnline ? "primary" : "secondary"}`}
            >
                <div className="card-body">
                    <div>
                        <span className="mr-1">
                            <T>Connection:</T>
                        </span>
                        {isOnline ? <T>Online</T> : <T>Offline</T>}
                    </div>
                    <div>
                        <span className="mr-1">
                            <T>Status:</T>
                        </span>
                        {intl2Num(intl, state)}
                    </div>
                    <div>
                        <span className="mr-1">
                            <T>Most recent measurement:</T>
                        </span>
                        {this.renderLastMeasurement()}
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <small>
                        <span className="mr-1">
                            <T>Last activity:</T>
                        </span>
                        <Time value={new Date(lastMessage)} />
                    </small>
                </div>
            </Card>
        );
    }

    @boundMethod
    private renderLastMeasurement() {
        const {device, lastMeasurement} = this.props.device;

        if (!lastMeasurement) {
            return (
                <em>
                    <T>No previous measurement found</T>
                </em>
            );
        }

        const {id, name, project} = lastMeasurement;
        const serverId = device2ServerId(device.deviceClass);

        return (
            <Link
                to={`/project/${project}/${serverId}/measurement/${id}`}
                target="_blank"
            >
                {name}
            </Link>
        );
    }
}

export default injectIntl(Device);
